import * as React from 'react';
import styled from 'styled-components';
import {GalleryContext} from '../gallery-core-v67.18';

const StyledEdge = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    cursor: pointer;
`;
export const FadingEdgesNavigation: React.FC<{index: number}> = props => {
    const {index} = props;
    const {
        triggerNext,
        triggerPrevious,
        slidesPerPage,
        index: activeIndex
    } = React.useContext(GalleryContext);
    const prev = index === activeIndex - 1;
    const next = index === activeIndex + slidesPerPage;

    return (
        <>
            {prev && <StyledEdge onClick={triggerPrevious} />}
            {next && <StyledEdge onClick={triggerNext} />}
        </>
    );
};
